exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th#VueTables_th--topic_id {\n  width: 200px;\n}\n#VueTables_th--name {\n  width: 300px;\n}\n@media (max-width: 768px) {\ninput.select-filter {\n    height: 45px;\n}\n.select-filter {\n    margin-bottom: 15px;\n}\n.select-filter .dropdown-toggle {\n    height: 45px;\n}\n.select-filter ul.dropdown-menu li {\n    padding: 5px 0px;\n}\n.select-filter .dropdown-toggle {\n    height: 45px;\n}\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};